import { ACTION_GCASH_ADD_TRANSACTION, ACTION_GCASH_ADD_TRANSACTION_ERROR, ACTION_GCASH_ADD_TRANSACTION_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";


export const gcashAddTransactionRequest = (access_token, tid, appInfo, url) => ({
    type: ACTION_GCASH_ADD_TRANSACTION,
    payload: {
        access_token,
        tid,
        appInfo,
        url
    }
})

export const gcashAddTransactionSuccess = data => ({
    type: ACTION_GCASH_ADD_TRANSACTION_SUCCESS,
    payload: {
        data
    }
})


export const gcashAddTransactionError = (msg) => ({
    type: ACTION_GCASH_ADD_TRANSACTION_ERROR,
    payload: {
        msg
    }
})

export const gcashAddTransaction = (access_token, tid, appInfo, url) => {
    return dispatch => {
        dispatch(gcashAddTransactionRequest(access_token, tid, appInfo, url))
        api.gcashAddTransaction(access_token, tid, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(gcashAddTransactionError("error"));
                    return
                }

                dispatch(gcashAddTransactionSuccess("success"));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(gcashAddTransactionError("system error"))
            });
    }
}